import { FC } from "react";
import DatePickerComponent from "ui/Date";
import { RegistrationOverviewParams } from "api/registration";
import { Vessel } from "interface/vessel";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { getCatchAreaApi, getFishingGearApi, getSpecies } from "api/common";
import { getVesselFilter } from "api/vessel";
import { FishingGear } from "interface/common";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";
import React from "react";

interface OverviewFilterProps {
	filterOptions: RegistrationOverviewParams;
	setFilterOptions: (options: RegistrationOverviewParams) => void;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}

const OverviewFilter: FC<OverviewFilterProps> = ({
	filterOptions,
	setFilterOptions,
	exportAsPDF,
	exportAsExcel,
}) => {
	const { t } = useTranslation();

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id ?? undefined,
			vesselName: vessel.id ? vessel.nm : "",
		});
	};

	const itemRender = (li: any, itemProps: any) => {
		const itemChildren = <span>{itemProps.dataItem.displayName}</span>;
		return React.cloneElement(li, li.props, itemChildren);
	};

	return (
		<div className="filter-container">
			<div className="filter-items registration-filter-items">
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("RegistrationDateFrom")}
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={filterOptions.registrationTimeFrom}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								registrationTimeFrom: e.target.value,
							})
						}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("RegistrationDateTo")}
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={filterOptions.registrationTimeTo}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								registrationTimeFrom: e.target.value,
							})
						}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("DeliveryDateFrom")}
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={filterOptions.landingTimeFrom}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								landingTimeFrom: e.target.value,
							})
						}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder=" "
						label={t("DeliveryDateTo")}
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={filterOptions.landingTimeTo}
						onChange={(e) =>
							setFilterOptions({
								...filterOptions,
								landingTimeTo: e.target.value,
							})
						}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						itemRender={VesselRenderItem()}
						value={{
							id: filterOptions.vesselId || null,
							//	nm: filterOptions.vesselName || t("ChooseVessel"),
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fartøy"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
						// popupSettings={{ width: 400 }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						onSelect={(species) =>
							setFilterOptions({
								...filterOptions,
								species: species.code,
							})
						}
						label={t("Species")}
						value={{
							code: filterOptions.species || null,
							name: filterOptions.species || " ",
						}}
						dataItemKey="code"
						textField="name"
						defaultItem={{ code: null, name: t("All") }}
						filterable={true}
						serverFilter={true}
						serverFilterApi={getSpecies}
						className="height-inherit"
						// popupSettings={{ width: 400 }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						onSelect={(p) =>
							setFilterOptions({
								...filterOptions,
								catchField: p.code,
								catchFieldName: p.name,
							})
						}
						label={t("CatchArea")}
						value={{
							code: filterOptions.catchField || null,
							//	name: filterOptions.catchField1Name || t("ChooseCatchArea"),
							name: filterOptions.catchFieldName || " ",
						}}
						dataItemKey="code"
						textField="name"
						itemRender={itemRender}
						defaultItem={{ code: null, name: t("All") }}
						filterable={true}
						serverFilter={true}
						serverFilterApi={getCatchAreaApi}
						className="height-inherit"
						// popupSettings={{ width: 400 }}
					/>
				</div>
				<div style={{ width: "200px" }}>
					<CustomDropDownList
						data={[]}
						value={{
							code: filterOptions.fishingGearId || null,
							//	displayName: filterOptions.fishingGear || t("ChooseFishingGear"),
							displayName: filterOptions.fishingGear || " ",
						}}
						className="height-inherit"
						dataItemKey="code"
						label={t("FishingGear")}
						textField="displayName"
						serverFilter={true}
						filterable={true}
						serverFilterApi={getFishingGearApi}
						defaultItem={{ value: null, displayName: t("All") }}
						onSelect={(gear: FishingGear) =>
							setFilterOptions({
								...filterOptions,
								fishingGearId: gear.id,
								fishingGear: gear.name,
							})
						}
						// popupSettings={{ width: 400 }}
					/>
				</div>
			</div>
			<div className="filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"Pdf"}*/}
				{/*	onClick={exportAsPDF}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={exportAsExcel}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default OverviewFilter;
